export enum GroupKey {
  GROUP = 'group',
  GROUPS = 'groups',
  GROUPS_INFINITE = 'groupsInfinite',
  GROUP_USERS = 'groupUsers',
  GROUP_ATTENDANCE = 'groupAttendance',
  ASSIGNED_GROUPS_INFINITE = 'assignedGroupsInfinite',
  GROUP_MEETINGS_INFINITE = 'groupMeetingsInfinite',
  GROUP_SHARED_FILES = 'groupSharedFiles',
  GROUP_QUIZZES_INFINITE = 'groupQuizzesInfinite',
  GROUP_POSTS_INFINITE = 'groupPostsInfinite',
}
